import React, { useState } from "react"
import { isMobile } from "react-device-detect"

type Placement = "top" | "bottom" | "left" | "right"

interface Props {
  content: string
  children: React.ReactNode
  placement?: Placement
}

const Tooltip: React.FC<Props> = ({ content, children, placement = "top" }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        className="focus:outline-none"
      >
        {children}
      </div>
      {showTooltip && (
        <div className={`absolute z-20 ${getPositionClasses(placement)} flex items-center hidden sm:hidden`}>
          <div className="relative w-max bg-white text-black text-sm shadow-md rounded-md px-4 py-1">
            <p className="text-gray-500">{content}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default Tooltip

const getPositionClasses = (placement: Placement) => {
  switch (placement) {
    case "top":
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
    case "bottom":
      return "top-full left-1/2 transform -translate-x-1/2 mt-2"
    case "left":
      return "right-full top-1/2 transform -translate-y-1/2 mr-2"
    case "right":
      return "left-full top-1/2 transform -translate-y-1/2 ml-2"
    default:
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
  }
}
